import { Button, Stack } from "@mui/material";
import BackLink from "../../../shared/BackLink";
import { useState } from "react";
import { useDb } from "../../../../contexts/DatabaseContext";
import { useCollectionData } from "react-firebase-hooks/firestore";
import RMFDataGrid from "../../../shared/data-grid/RMFDataGrid";
import moment from "moment";
import RunManualDateRangeBlueLabel from "./RunManualDateRangeBlueLabel";

export default function BlueLabelReports() {
  const [manualOpen, setManualOpen] = useState(false);
  const { blueLabelReportsCollection } = useDb();

  const [value, loading, error] = useCollectionData(blueLabelReportsCollection);

  console.log(value);

  const rows =
    value &&
    value.map((row, index) => ({
      ...row,
      id: index,
      date: moment(row.created.toDate()).format("YYYY-MM-DD HH:mm"),
    }));

  rows &&
    rows.sort((a, b) => {
      console.log("Sorting Rows ... ");
      // For descending order, we want the larger (later) date string (b) to come first.
      // JavaScript's localeCompare provides a simple and accurate way to compare strings chronologically.
      // If b.date is chronologically later than a.date, it returns 1 (which puts b before a).
      return b.date.localeCompare(a.date);
    });

  const columns = [
    {
      field: "title",
      headerName: "File Name",
      width: 400,
      renderCell: (params) => {
        return (
          <Button
            href={params.row.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            size="small"
          >
            {params.row.title}
          </Button>
        );
      },
    },
    { field: "date", headerName: "Report Date", width: 200 },
  ];

  console.log(rows);

  return (
    <div>
      <h1>Blue Label Reports</h1>
      <BackLink />

      <Button
        color="primary"
        variant="contained"
        onClick={() => setManualOpen(true)}
      >
        Run Manual Date
      </Button>
      <br />
      <br />
      <Stack spacing={2}>
        {rows && <RMFDataGrid data={rows} columns={columns} />}
      </Stack>

      <RunManualDateRangeBlueLabel
        open={manualOpen}
        close={() => setManualOpen(false)}
      />
    </div>
  );
}
